export default __webpack_public_path__ + "static/services-details1-eb8b4d0931401a7b19fe8d0a26bb5cfb.jpg";